import { Box, keyframes, styled } from '@mui/material';
import { forwardRef } from 'react';

import snowflakesBig from './assets/snowflakes-big.svg';
import snowflakesSmallA from './assets/snowflakes-small-a.svg';
import snowflakesSmallB from './assets/snowflakes-small-b.svg';

// Svg file dimensions
const size = {
  width: 447,
  height: 313,
};

const slideAnim = keyframes({
  '0%': {
    translate: '0 calc(-1 * var(--height) * var(--scale))',
  },
  '100%': {
    translate: `0 0`,
  },
});

const SnowfallImpl = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: 'big' | 'small-a' | 'small-b' }>(({ theme, variant }) => ({
  '--scale': '0.6',
  '--width': `${size.width}px`,
  '--height': `${size.height}px`,

  [`@container (min-width: ${theme.breakpoints.values.sm}px)`]: {
    '--scale': '0.7',
  },
  [`@container (min-width: ${theme.breakpoints.values.md}px)`]: {
    '--scale': '0.8',
  },
  [`@container (min-width: ${theme.breakpoints.values.lg}px)`]: {
    '--scale': '1',
  },

  width: '100%',
  height: 'calc(100% + var(--height) * var(--scale))',
  backgroundImage: `url("${variant === 'big' ? snowflakesBig : variant === 'small-a' ? snowflakesSmallA : snowflakesSmallB}")`,
  backgroundPositionX: variant === 'big' ? 8 : variant === 'small-a' ? 0 : -2,
  backgroundSize: `calc(var(--width) * var(--scale)) calc(var(--height) * var(--scale))`,
  animation: `${slideAnim} ${variant === 'big' ? '5' : variant === 'small-a' ? '8' : '20'}s linear infinite`,
  pointerEvents: 'none',
  gridArea: '1 / 1 / 2 / 2',

  [`@media (prefers-reduced-motion: reduce)`]: {
    animation: 'none',
  },
}));

type SnowfallProps = React.ComponentProps<typeof Box>;

export const Snowfall = forwardRef<HTMLDivElement, SnowfallProps>((props, ref) => (
  <Box
    {...props}
    ref={ref}
    style={{
      containerType: 'size',
      display: 'grid',
      pointerEvents: 'none',
      overflow: 'hidden',
    }}
  >
    <SnowfallImpl variant="big" />
    <SnowfallImpl variant="small-a" />
    <SnowfallImpl variant="small-b" />
  </Box>
));
